/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon16Light = forwardRef('WeatherThermometerIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 9.322V5.5a.5.5 0 0 0-1 0v3.822a1.75 1.75 0 1 0 1 0Zm-.5.928a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4a3 3 0 0 1 6 0v3.99a4.25 4.25 0 1 1-6 0V4Zm3-2a2 2 0 0 0-2 2v4.205a.5.5 0 0 1-.167.372 3.25 3.25 0 1 0 4.333 0A.5.5 0 0 1 10 8.205V4a2 2 0 0 0-2-2Z" })));
});
